import { TransferRuleDirection } from "@common/types/transactionRule";
import type { TagProps } from "@design-system/Tag/Tag";

export const RULE_TAG_PROPS = {
    color: "neutral",
    outline: true,
} as const satisfies Partial<TagProps>;

export function getDirectionLabel(
    base: string,
    direction?: TransferRuleDirection | null,
): string {
    if (direction === TransferRuleDirection.TO) {
        return `To ${base.toLowerCase()}`;
    }
    if (direction === TransferRuleDirection.FROM) {
        return `From ${base.toLowerCase()}`;
    }
    return base;
}
